import React from 'react';

function Card({ card, onClick }) {
  return (
    <div
      className={`memory-card${!card.passed && card.isFlipped ? " flip" : ""}`}
      onClick={onClick}
      style={{ order: card.order }}
      data-testid={card.id}
    >
      <img className="front-face" src={card.image} alt="Card" />
      <img className="back-face" src={"./assets/images/" + (card.passed ? "cardMatched" : "cardBack") + ".png"} />
    </div>
  );
}

export default Card;
